module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8zYUv"))).then(() => parcelRequire('2KbAe'));